import { showError } from "../components/ErrorPopup";
import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiFetch } from '../utils/apiClient';
import Select from "react-select";
import UsersList from "../components/UsersList";
import { TrashIcon } from "@heroicons/react/solid";
import { XCircleIcon } from "@heroicons/react/solid";
import { io } from "socket.io-client";
const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); 

const FormAchatEI = ({ user, enabled, checkGroupAdmin, checkGroupConsultationAchatEI }) => {
  const [isSubmitted, setIsSubmitted] = useState(false); // State to control popup
  const [message, setMessage] = useState("");
  const [couleur, setcouleur] = useState("");
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const [codeBudgetaire, setCodeBudgetaire] = useState([]);
   const [lieuxTravail, setLieuxTravail] = useState([]);
  const [selectedFormFromUrl, setSelectedFormFromUrl] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const numeroFormulaireFromUrl = queryParams.get("numeroFormulaire");
  const pageFromUrl = queryParams.get("page");
  const selectedForm = location.state?.selectedForm || selectedFormFromUrl;
  const page = location.state?.page || pageFromUrl;
  const navigate = useNavigate(); // Initialize navigate hook
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isLoadingDirectRequest, setIsLoadingDirectRequest] = useState(
    Boolean(numeroFormulaireFromUrl && !location.state?.selectedForm)
  );
  const [directRequestError, setDirectRequestError] = useState("");
  // const [showTable, setShowTable] = useState(false);


const [excelData, setExcelData] = useState([]);
const [commentaire, setCommentaire] = useState("");

useEffect(() => {
  if (location.state?.selectedForm || !numeroFormulaireFromUrl) return;

  if (!pageFromUrl) {
    setDirectRequestError("Le lien de la demande est incomplet.");
    setIsLoadingDirectRequest(false);
    return;
  }

  if (!user?.id) return;

  let isCancelled = false;

  const fetchSelectedForm = async () => {
    setIsLoadingDirectRequest(true);
    setDirectRequestError("");

    try {
      const params = new URLSearchParams({
        numeroFormulaire: numeroFormulaireFromUrl,
        page: pageFromUrl,
      });
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/selectedFormAchatEI?${params.toString()}`
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.error || data.message || "Impossible d'ouvrir cette demande."
        );
      }

      if (!isCancelled) setSelectedFormFromUrl(data);
    } catch (error) {
      if (!isCancelled) {
        setDirectRequestError(
          error.message || "Impossible d'ouvrir cette demande."
        );
      }
    } finally {
      if (isCancelled) return;

      setTimeout(() => {
        if (!isCancelled) setIsLoadingDirectRequest(false);
      }, 400);
    }
  };

  fetchSelectedForm();

  return () => {
    isCancelled = true;
  };
}, [
  location.state?.selectedForm,
  numeroFormulaireFromUrl,
  pageFromUrl,
  user?.id,
]);


const handleUserSelect = (user, fieldName) => {
    handleChange({
      target: {
        name: fieldName,
        value: {
          nom: user.displayName,
          email: user.mail,
          userId: user.id,
          matricule :user.employeeId,
          etatDemande:""
        },
      },
    });
  };

useEffect(() => {
  const getdata = async () => {
    try {

      const res = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/fiche`
      );
      const data = await res.json();
          if (!res.ok) {
            throw new Error(data.error || data.message);
          }

      setExcelData(data);

    } catch (err) {
      console.error(err);
      renderError?.("Impossible de récupérer les articles.");
    }
  };

  if (user?.id) {
    getdata();
  }

}, [user]);


useEffect(() => {
  async function fetchData() {
    try {
      const [centreCoutRes, lieuxTravailRes] = await Promise.all([
        apiFetch(`${process.env.REACT_APP_API_BASE_URL}/CentreCout`),
        apiFetch(`${process.env.REACT_APP_API_BASE_URL}/lieux-travail`),
      ]);

      const [centreCoutData, lieuxTravailData] = await Promise.all([
        centreCoutRes.json(),
        lieuxTravailRes.json(),
      ]);

      setCodeBudgetaire(centreCoutData);
      setLieuxTravail(lieuxTravailData);
    } catch (error) {
      console.error("Erreur lors du chargement des données :", error);
    }
  }

  fetchData();
}, []);
  


  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-${yy}${mm}${dd}${randomNumber}-AEI`;
  };

  const initialFormData = {
    numeroFormulaire: generateNumeroFormulaire(),
    dateSoumission: new Date().toISOString().split("T")[0],
    achats: [],
    total: selectedForm?.total || 0,
    etatDemande: selectedForm?.etatDemande || "",
    codeBudgetaire: selectedForm?.codeBudgetaire || "",
    codeBudgetaireAutre:selectedForm?.codeBudgetaireAutre || "",
    traitant: selectedForm?.traitant || [],
    managerInfo: selectedForm?.managerInfo || {
          nom: "",
          email: "",
          userId: "",
          matricule: "",
          etatDemande: "",
        },
    lieuTravail:selectedForm?.lieuTravail || "",
    SignatureElectronique: selectedForm?.SignatureElectronique || "non",
  };
  // console.log("selected Form: ", selectedForm);
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
      if (user && !selectedForm) {
        setFormData((prevData) => ({
          ...prevData,
          userId: user.id,
          nom: user.displayName,
          matricule: user.employeeId,
          poste: user.jobTitle,
          courriel: user.mail,
        }));
      }
      
      if (selectedForm) {
        const isConsultationOnly =
          selectedForm.consultationOnly === true ||
          (page === "Mes taches" &&
            checkGroupConsultationAchatEI &&
            !checkGroupAdmin &&
            selectedForm.traitant?.at(-1)?.userId !== user?.id);

        if (
        isConsultationOnly ||
        (
        selectedForm.etatDemande !== "Brouillon" &&
        selectedForm.etatDemande !== "Rejeté" &&
        page !== "Mes taches")
        ||
        ((selectedForm.etatDemande === "Approuvé" ||
        selectedForm.etatDemande === "Rejeté") &&
        page === "Mes taches")
      ) {
        setIsReadOnly(true);
      } else {
        setIsReadOnly(false);
      }
        
        setFormData((prevData) => ({
          ...prevData,
          userId: selectedForm.userId,
          nom: selectedForm.nom,
          matricule: selectedForm.matricule,
          poste: selectedForm.poste,
          courriel: selectedForm.courriel,
          numeroFormulaire: selectedForm.numeroFormulaire,
          dateSoumission:
            selectedForm.etatDemande === "Brouillon"
              ? new Date().toISOString().split("T")[0]
              : selectedForm.dateSoumission || prevData.dateSoumission,
          achats: selectedForm?.achats || [],
          total:selectedForm?.total || 0,
          etatDemande: selectedForm?.etatDemande || "",
          codeBudgetaire: selectedForm?.codeBudgetaire || "",
          codeBudgetaireAutre:selectedForm?.codeBudgetaireAutre || "",
          managerInfo: selectedForm?.managerInfo || {
            nom: "",
            email: "",
            userId: "",
            matricule: "",
            etatDamande: "",
          },
          traitant: selectedForm?.traitant || [],
          lieuTravail:selectedForm?.lieuTravail || "",
          SignatureElectronique: selectedForm?.SignatureElectronique || "non",
        }));
      }
      
    }, [user, selectedForm, page, checkGroupAdmin, checkGroupConsultationAchatEI]);




 const handleFormAction = async (e, actionType, updatedTraitant = null) => {
  e.preventDefault();

  const currentDate = new Date();

  const updatedFormData = {
    ...formData,
    etatDemande: actionType,
    dateSoumission: currentDate,
    traitant: updatedTraitant ?? formData.traitant ?? [],
  };

  const method = selectedForm ? "PUT" : "POST";
  const formType = "AchatEI";
  const url = selectedForm
    ? `${process.env.REACT_APP_API_BASE_URL}/form/${selectedForm._id}?form=${formType}`
    : `${process.env.REACT_APP_API_BASE_URL}/form?form=${formType}`;

  try {
    const response = await apiFetch(url, {
     method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedFormData),
    });

    const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message);
      }

      if(updatedFormData.etatDemande !== "Brouillon"){
          if (socket) {
          socket.emit("requestUpdated");
        }
        }

      setIsSubmitted(true);
      await new Promise((resolve) => {
        setTimeout(() => {
          setIsSubmitted(false);
          resolve();
        }, 3000);
      });

      setErrors({});
      
      if (page === "Mes taches") {
        if (window.opener && !window.opener.closed) {
          window.close();
        } else {
          navigate("/taches", { state: { selectedForm: null } });
        }
      } else {
        navigate("/demande", { state: { selectedForm: null } });
      }
    
  } catch (error) {
      console.error(error);
      showError(error); // ou setError(error.message)
    }
};

   const handleChange = (e) => {
  const { name, value } = e.target;
  let newValue = value;

  setFormData((prevData) => {
    let updatedData = {
      ...prevData,
      [name]: newValue,
    };

    // 🔥 Cas spécial : poste
    if (name === "poste") {
      const isDirection = /(direction|directeur|directrice)/i.test(newValue || "");

      if (isDirection) {
        updatedData.managerInfo = {
          nom: "",
          email: "",
          userId: "",
          matricule: "",
          etatDemande: "",
        };
      }
    }

    return updatedData;
  });

  setErrors("");
};

    const hasManager = (managerInfo) => {
      return !!(
        managerInfo &&
        (managerInfo.userId?.trim() || managerInfo.email?.trim() || managerInfo.nom?.trim())
      );
    };

   // petite fonction réutilisable pour ajouter un traitant sans doublon
const addTraitantEntry = (etat) => {
  const currentUser = {
    userId: user?.id || "",
    nom: user?.displayName || "",
    email: user?.mail || "",
    matricule: user?.employeeId || "",
    etatDemande: etat,
    commentaire: commentaire || "",
    dateHeure: new Date(),
  };

  const existingTraitants = formData.traitant || [];

  return [...existingTraitants, currentUser];
};
const handleSubmit = (e) => {
  e.preventDefault();
  if (!validateForm()) return;

  const managerExists = hasManager(formData.managerInfo);

  const actionType = managerExists ? "En traitement" : "Soumis";

  const updatedTraitant = managerExists
  ? [
      ...(formData.traitant || []),
      {
        userId: formData.managerInfo.userId,
        nom: formData.managerInfo.nom,
        email: formData.managerInfo.email,
        matricule: formData.managerInfo.matricule,
        etatDemande: "En traitement",
        commentaire: "",
        dateHeure: new Date(),
      }
    ]
  : (formData.traitant || []);

  handleFormAction(e, actionType, updatedTraitant);

  setMessage(
    managerExists
      ? "Succès ! La demande est maintenant en traitement."
      : "Succès ! Le formulaire a été soumis."
  );
  setcouleur("text-green-600");
};

const handleApprouve = (e) => {
  e.preventDefault();
  if (!validateForm()) return;

  const updatedTraitant = addTraitantEntry("Approuvé");

  handleFormAction(e, "Approuvé", updatedTraitant);
  setMessage("Succès ! Le formulaire a été Approuvé.");
  setcouleur("text-green-600");
  setErrors("");
};

const handleRejeter = (e) => {
  e.preventDefault();
  if (!validateForm()) return;

  const updatedTraitant = addTraitantEntry("Rejeté");

  handleFormAction(e, "Rejeté", updatedTraitant);
  setMessage("Le formulaire a été Rejeté.");
  setcouleur("text-red-700");
  setErrors("");
};

  const handleSave = (e) => {
    handleFormAction(e, "Brouillon"); // Use "Enregistrer" for save action
    setMessage("Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis.");
    setcouleur("text-grey-600")
    setErrors("");
  };

  const validateForm = () => {
  const newErrors = {};

  if (!formData.nom) newErrors.nom = "Ce champ est requis.";
  if (!formData.courriel) newErrors.courriel = "Ce champ est requis.";
  if (!formData.poste) newErrors.poste = "Ce champ est requis.";
  
  if (!formData.codeBudgetaire) newErrors.codeBudgetaire = "Ce champ est requis.";
  if (!formData.lieuTravail) newErrors.lieuTravail = "Ce champ est requis.";
if (formData.SignatureElectronique === "non") {
      newErrors.SignatureElectronique =
        "Veuillez accepter et signer électroniquement pour continuer.";
    }
  if (
    !/(direction|directeur|directrice)/i.test(formData.poste || "") &&
    (!formData.managerInfo?.nom || formData.managerInfo.nom.trim() === "")
  ) {
    newErrors.managerInfo = "Ce champ est requis.";
  }

  if (!formData.achats || formData.achats.length === 0) {
    newErrors.achats = "Veuillez ajouter au moins un équipement.";
  } else {
    formData.achats.forEach((achat, index) => {
      if (!achat.choix || achat.choix.trim() === "") {
        newErrors[`achats.${index}.choix`] = "Veuillez séléctionner un choix.";
      }

      if (!achat.description || achat.description.trim() === "") {
        newErrors[`achats.${index}.description`] = "Veuillez ajouter une description.";
      }

      if (!achat.quantite || String(achat.quantite).trim() === "") {
        newErrors[`achats.${index}.quantite`] = "Veuillez ajouter la quantité.";
      }

      if (achat.choix === "Autre" && (!achat.prix || String(achat.prix).trim() === "")) {
        newErrors[`achats.${index}.prix`] = "Veuillez ajouter le prix.";
      }
    });
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const renderError = (field) => {
    return errors[field] ? (
      <p className="flex items-center gap-1.5 text-sm text-red-500 mt-1">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-100 text-red-500 text-[10px] font-bold flex-shrink-0">
          !
        </span>
        {errors[field]}
      </p>
    ) : null;
  };


  const handleDescriptionChange = (index, description) => {

  const selected = excelData.find(
    row => row.description === description
  );

  const updated = [...formData.achats];

  updated[index].description = description;
  updated[index].prix = selected?.prix || 0;
  updated[index].fournisseur = selected?.fournisseur || "";
  updated[index].numeroPiece= selected?.numeroPiece || "";

  setFormData({
    ...formData,
    achats: updated
  });
  setErrors("");
};

const handleAchatChange = (index, field, value) => {

  const updated = [...formData.achats];

  updated[index][field] = value;

  setFormData({
    ...formData,
    achats: updated
  });
  setErrors("");
};
  
const handleAddAchat = () => {

  const updated = [...formData.achats];

  updated.push({
    choix: "",
    description: "",
    prix: 0,
    quantite: 1,
    fournisseur:"",
    numeroPiece:"",
  });

  setFormData({
    ...formData,
    achats: updated
  });
setErrors("");
};

const handleDeleteAchat = (index) => {

  const updated = [...formData.achats];

  updated.splice(index, 1);

  setFormData({
    ...formData,
    achats: updated
  });

};


const totalGeneral = formData.achats.reduce((sum, item) => {
  const prix = Number(item.prix) || 0;
  const quantite = Number(item.quantite) || 0;
  return sum + prix * quantite;
}, 0);
useEffect(() => {
  setFormData(prev => ({
    ...prev,
    total: totalGeneral
  }));
}, [totalGeneral]);



// HandleChange générique
  const handleChangeCheckBox = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "oui" : "non") : value,
    }));
  };



if (directRequestError) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-lg rounded-lg border border-red-200 bg-white p-6 text-center shadow-sm">
        <XCircleIcon className="mx-auto mb-3 h-12 w-12 text-red-500" />
        <h3 className="mb-2 text-xl font-semibold text-gray-900">
          Impossible d'ouvrir cette demande
        </h3>
        <p className="text-gray-600">{directRequestError}</p>
      </div>
    </div>
  );
}

if (
  !isLoadingDirectRequest &&
  (
    (!enabled && !selectedForm && page !== "Mes taches") ||
    (!enabled &&
      selectedForm &&
      selectedForm.etatDemande === "Brouillon" &&
      page !== "Mes taches")
  )
) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
      <XCircleIcon className="h-16 w-16 text-red-500 mb-4 animate-pulse" />
      <h3 className="text-2xl font-bold text-red-600 mb-2">
        Formulaire Achat équipement informatique fermé
      </h3>
      <p className="text-gray-700 max-w-md">
        Le formulaire est désormais fermé.
      </p>
    </div>
  );
}
  return (
     <div className="relative min-h-screen p-8 bg-gray-100 rounded-lg shadow-lg">
      
      

        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="numeroFormulaire"
              className="block text-sm font-medium text-blue-900"
            >
              Numéro de formulaire:
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              name="numeroFormulaire"
              value={formData.numeroFormulaire}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
          </div>
        </div>

        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date :
            </label>
            <input
              type="date"
              id="dateSoumission"
              name="dateSoumission"
              value={formData.dateSoumission?.split("T")[0] ?? ""}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>

        {/* <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-8 shadow-sm">

          <p className="text-gray-700 leading-relaxed mb-3">
            Identifier les quantités à commander
          </p>

          <p className="text-gray-700 leading-relaxed">
           S'il y a des articles à commander qui ne figurent pas sur la liste, les inscrire dans la section «Autre»
          </p>

        </div> */}
<div className="w-full flex justify-center mt-6 mb-20">
  <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
    <p className="text-md font-bold flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
        />
      </svg>
      Formulaire d'achats d'équipement informatique
    </p>
  </div>
</div>
<div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-blue-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    Information du membre du personnel
  </p>
</div>
          <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="nom"
              className="block text-sm font-medium text-blue-900"
            >
              Nom <span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("nom")}
          </div>
          
          <div className="w-3/5">
            <label
              htmlFor="courriel"
              className="block text-sm font-medium text-blue-900"
            >
              Courriel <span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="courriel"
              name="courriel"
              value={formData.courriel}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("courriel")}
          </div>
        </div>

         <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="poste"
              className="block text-sm font-medium text-blue-900"
            >
              Poste: <span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="text"
              id="poste"
              name="poste"
              value={formData.poste}
              readOnly={isReadOnly}
              onChange={handleChange}
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("poste")}
          </div>
        </div>

        <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="codeBudgetair"
              className="block text-sm font-medium text-blue-900"
            >
              Code Budgetaire: <span className="text-xl text-red-900" >*</span>:
            </label>
           <Select
              id="codeBudgetaire"
              name="codeBudgetaire"
              options={[
                  ...codeBudgetaire.map((code) => ({
                    value: code.value,
                    label: String(code.value),
                  })),
                  { value: "AUTRE", label: "Autre" },
                ]}

              onChange={(selectedOption) => {
                if (isReadOnly) return;

                handleChange({
                  target: {
                    name: "codeBudgetaire",
                    value: selectedOption ? selectedOption.value : "",
                  },
                });
              }}

              placeholder="Séléctionner"

              value={
                formData.codeBudgetaire
                  ? {
                      value: formData.codeBudgetaire,
                      label: String(formData.codeBudgetaire),
                    }
                  : null
              }

              isClearable={!isReadOnly}
              menuPlacement="auto"

              className="react-select-container"
              classNamePrefix="react-select"

              filterOption={(option, inputValue) =>
                option.label.toLowerCase().startsWith(inputValue.toLowerCase())
              }

              menuIsOpen={isReadOnly ? false : undefined}
            />
            {formData.codeBudgetaire === "AUTRE" && (
  <div className="mt-3">
    <input
      type="text"
      readOnly={isReadOnly}
      placeholder="Entrer le code budgétaire"
      className="w-full p-2 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
      value={formData.codeBudgetaireAutre || ""}
      onChange={(e) => {
        const value = e.target.value.replace(/\D/g, ""); // enlève tout sauf les chiffres
        setFormData((prev) => ({
          ...prev,
          codeBudgetaireAutre: value,
        }));
      }}
    />
  </div>
)}
            {renderError("codeBudgetaire")}
          </div>
          
          <div className="w-3/5 ">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Lieu de travail<span className="text-xl text-red-900" >*</span> :
            </label>
            <select
              id="lieuTravail"
              name="lieuTravail"
              value={formData.lieuTravail}
              onChange={handleChange}
                disabled={isReadOnly}
  className={`mt-1 w-full p-3 border border-gray-200 rounded-xl shadow-sm
  focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200
  bg-white ${isReadOnly ? "text-gray-800 opacity-100 cursor-default" : ""}`}
    >
              <option value="">Selectionner un lieu</option>
              {lieuxTravail.map((lieu) => (
                <option key={lieu._id} value={lieu.nom}>
                  {lieu.nom}
                </option>
              ))}
              
            </select>
            {renderError("lieuTravail")}
          </div>
        </div>

{!/(direction|directeur|directrice)/i.test(formData.poste || "") && (
        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5">
            <label
              htmlFor="fileUpload"
              className="block text-sm font-medium text-blue-900 mb-2"
            >
              Direction d'école <span className="text-xl text-red-900" >*</span> :
            </label>
            <div className="relative">
              {/* Add the UsersList component with the callback for user selection */}
             {isReadOnly===false && !formData?.managerInfo?.nom && (<UsersList onUserSelect={(user) => handleUserSelect(user, "managerInfo")} initialValue={formData?.managerInfo?.email}/>)}

                {/* Display the selected user's information */}
                {formData?.managerInfo?.nom && (
                  <div className="mt-4 p-4 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                    {/* Avatar */}
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                      {formData.managerInfo.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.managerInfo.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.managerInfo.email}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            managerInfo: {
                              nom: "",
                              email: "",
                              userId: "",
                              matricule: "",
                              etatDemande: "",
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
            </div>
            {renderError("managerInfo")}
          </div>
        </div>
      )}

            
          
 <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl mt-10">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
   <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-blue-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.75 17L8 21h8l-1.75-4M3 13h18M5 3h14a2 2 0 012 2v8H3V5a2 2 0 012-2z"
      />
    </svg>
    Liste des équipements
  </p>
</div>
  
<div className="w-full mt-10">

  {/* HEADER */}
  <div className="flex items-start justify-between mb-6">
    <div>
      <h3 className="text-xl font-semibold text-gray-800 tracking-tight">
        Achat d'équipement informatique
      </h3>
      <p className="text-sm text-gray-600 mt-1">
        Séléctionner les équipements désirés
      </p>
    </div>
  </div>

  {/* TABLE */}
  <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-md">
    <table className="w-full text-md">

      <thead className="bg-blue-600 text-white">
        <tr>
          <th className="px-4 py-3 text-left w-[25%]">Choix</th>
          <th className="px-4 py-3 text-left w-[30%]">Description</th>
          <th className="px-4 py-3 text-left w-[7%]">Prix</th>
          <th className="px-4 py-3 text-left w-[8%]">Quantité</th>
          <th className="px-4 py-3 text-left w-[10%]">Total</th>
          <th className="px-4 py-3 text-center w-[2%]">Action</th>
        </tr>
      </thead>

      <tbody className="divide-y divide-gray-100">

        {formData.achats?.map((item, index) => {

          const isAutre = item.choix === "Autre";
          const descriptions = excelData.filter(
            row => row.choix === item.choix
          );
          const prix = item.prix || 0;
          const total = prix * (item.quantite || 0);

            return (
      <tr key={index} className="hover:bg-blue-50/40 transition">
        {/* CHOIX */}
        <td className="px-4 py-3">
          <select
            disabled={isReadOnly }
            className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
            focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={item.choix || ""}
            onChange={(e) => {
              const newChoix = e.target.value;

              handleAchatChange(index, "choix", newChoix);

              // Reset champs selon le choix
              if (newChoix === "Autre") {
                handleAchatChange(index, "description", "");
                handleAchatChange(index, "prix", "");
              } else {
                handleAchatChange(index, "description", "");
                handleAchatChange(index, "prix", 0);
              }
            }}
          >
            <option value="">Séléctionner</option>

            {[...new Set(excelData.map((row) => row.choix))].map((choix) => (
              <option key={choix} value={choix}>
                {choix}
              </option>
            ))}

            {/* ✅ Option Autre */}
            <option value="Autre">Autre</option>
          </select>
          {renderError(`achats.${index}.choix`)}
        </td>

        {/* DESCRIPTION */}
        <td className="px-4 py-3">
          {isAutre ? (
            <textarea
              rows={3}
              placeholder="Saisir la description..."
              className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
              focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
              value={item.description || ""}
              onChange={(e) =>
                handleAchatChange(index, "description", e.target.value)
              }
              readOnly={isReadOnly}
            />
          ) : (
            <select
              className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
              focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={item.description || ""}
              onChange={(e) => handleDescriptionChange(index, e.target.value)}
              disabled={!item.choix || isReadOnly } // optionnel: bloque si pas de choix
            >
              <option value="">Séléctionner</option>

              {descriptions.map((row, i) => (
                <option key={i} value={row.description}>
                  {row.description}
                </option>
              ))}
            </select>
          )}
          {renderError(`achats.${index}.description`)}
        </td>

        {/* PRIX */}
        <td className="px-4 py-3">
            {isAutre ? (
              <input
                type="text"
                inputMode="decimal"
                placeholder="0.00"
                className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
                focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={item.prix ?? ""}
                onChange={(e) => {
                  const value = e.target.value;

                  // accepte chiffres + point decimal
                  if (/^\d*\.?\d*$/.test(value)) {
                    handleAchatChange(index, "prix", value);
                  }
                }}
                readOnly={isReadOnly}
              />
            ) : (
              <input
                type="text"
                className="w-full bg-gray-100 border border-gray-200 rounded-xl px-3 py-2"
                value={prix}
                readOnly
              />
            )}
           {renderError(`achats.${index}.prix`)}
          </td>

        {/* QUANTITÉ */}
        <td className="px-4 py-3">
          <input
            type="text"
            inputMode="numeric"
            className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
            focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={item.quantite || ""}
            onChange={(e) => {
              const value = e.target.value;

              // accepte seulement chiffres
              if (/^\d*$/.test(value)) {
                handleAchatChange(index, "quantite", value);
              }
            }}
            readOnly={isReadOnly}
          />
          {renderError(`achats.${index}.quantite`)}
        </td>

        {/* TOTAL */}
        <td className="px-4 py-3">
          <input
            type="text"
            className="w-full bg-gray-100 border border-gray-200 rounded-xl px-3 py-2 font-medium"
            value={Number.isFinite(total) ? total.toFixed(2) : "0.00"}
            readOnly
          />
        </td>

        {/* ACTION */}
        <td className="px-4 py-3 text-center">
          {isReadOnly===false && (
          <button
            type="button"
            onClick={() => handleDeleteAchat(index)}
            className="inline-flex items-center justify-center p-2 rounded-xl
            hover:bg-red-50 active:scale-95 transition group"
          >
            <TrashIcon className="w-5 h-5 text-red-500 group-hover:text-red-600 transition" />
          </button>)}
        </td>
      </tr>
    );
  })}
</tbody>
    </table>
{/* TOTAL GENERAL */}
<div className="flex justify-end px-6 py-5 border-t bg-gray-50">
  <div className="flex items-center gap-6 bg-white border border-gray-200 rounded-2xl px-6 py-4 shadow-sm">
    
    <div className="flex flex-col">
      <span className="text-sm text-gray-500 tracking-wide">
        Total (avant taxes)
      </span>
      <span className="text-xl font-bold text-green-600">
        {totalGeneral.toFixed(2)} $
      </span>
    </div>

  </div>
</div>

  </div>
</div>
{isReadOnly===false && (
<div className="mt-6 flex flex-col items-start gap-2">

  <button
    type="button"
    onClick={handleAddAchat}
    className="
      inline-flex items-center gap-2
      px-6 py-2.5
      bg-blue-600 hover:bg-blue-700
      text-white text-sm font-medium
      rounded-xl
      shadow-sm hover:shadow-md
      active:scale-[0.98]
      transition-all duration-200
    "
  >
    <span className="text-lg leading-none">+</span>
    Ajouter un équipement
  </button>
{renderError("achats")}
</div>)}

{/* Checkbox */}
<div className="mt-10 p-5 bg-white rounded-2xl shadow-lg border border-gray-200">
  <label className="flex items-center cursor-pointer space-x-4 relative">
    {/* Hidden checkbox but still part of layout */}
    <input
      type="checkbox"
      name="SignatureElectronique"
      checked={formData.SignatureElectronique === "oui"}
      onChange={handleChangeCheckBox}
      className="absolute opacity-0 w-6 h-6"
      disabled={isReadOnly || page === "Mes taches" }
    />
    {/* Custom box */}
        <span className="flex items-center justify-center h-6 w-6 rounded-lg border-2 border-gray-300 bg-gray-50 transition-all duration-300 
      checked:border-blue-500 peer-checked:bg-blue-50">
      {/* Check icon */}
      {formData.SignatureElectronique === "oui" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-10 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={3}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      )}
    </span>
    {/* Label text */}
    <span className="text-gray-900 font-medium text-sm select-none">
      Je certifie que les informations fournies sont exactes, complètes et vérifiées.
    </span>
    {renderError("SignatureElectronique")}
  </label>
</div>

          {/* ===== COMMENTAIRE RH (TOUS) ===== */}
          {page === "Mes taches" && !isReadOnly && formData.etatDemande ==="En traitement" &&(
    <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
         
          <div className="w-full mt-4">
                <label
                  htmlFor="commentaireRh"
                  className="block text-sm font-medium text-blue-900"
                >
                  Commentaire:
                </label>
                <textarea
                  placeholder="Ajoutez une qualification..."
                  className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  rows="5"
                  id="commentaire"
                  name="commentaire"
                  value={commentaire}
                  onChange={(e) => setCommentaire(e.target.value)}
                />
                {renderError("commentaireRH")}
              </div>
        </div>)}


        {/* Privacy Statement */}
 
        <div className="flex justify-start mt-16">
          {/* Left-aligned Buttons */}
          <div className="flex gap-4">

            {(formData.etatDemande === "Brouillon" ||
            formData.etatDemande === "")  && (
              <button
                type="button"
                onClick={handleSave}
                className="
          flex items-center justify-center
          px-5 py-2.5 rounded-xl text-sm font-medium
          bg-gray-700 text-white
          hover:bg-gray-600 active:scale-95
          transition-all duration-200 shadow-sm hover:shadow-md w-24
        "
              >
                Enregistrer
              </button>)}

            {(formData.etatDemande === "Brouillon" ||
              formData.etatDemande === "" ||
              (formData.etatDemande === "Rejeté" && page !== "Mes taches")) &&(
            <button
              type="button"
              onClick={handleSubmit}
              className="
          flex items-center justify-center
          px-5 py-2.5 rounded-xl text-sm font-medium
          bg-green-600 text-white
          hover:bg-green-500 active:scale-95
          transition-all duration-200 shadow-sm hover:shadow-md w-24
        "
            >
              Soumettre
            </button>)}
          {page === "Mes taches" && selectedForm && !isReadOnly && (selectedForm.etatDemande !== "Rejeté" && selectedForm.etatDemande !== "Soumis" && selectedForm.etatDemande !== "Approuvé") && (
            <button
              type="button"
              className="
            flex items-center justify-center
            px-5 py-2.5 rounded-xl text-sm font-medium
            bg-red-600 text-white
            hover:bg-red-500 active:scale-95
            transition-all duration-200 shadow-sm hover:shadow-md w-24
          "
              onClick={handleRejeter}
            >
              Rejeter
            </button>
          )}
          {page === "Mes taches" && selectedForm && !isReadOnly && (selectedForm.etatDemande !== "Rejeté" && selectedForm.etatDemande !== "Soumis" && selectedForm.etatDemande !== "Approuvé") && (
            <button
              type="button"
               className="
            flex items-center justify-center
            px-5 py-2.5 rounded-xl text-sm font-medium
            bg-green-600 text-white
            hover:bg-green-500 active:scale-95
            transition-all duration-200 shadow-sm hover:shadow-md w-24
          "

              onClick={handleApprouve}
            >
              Approuver
            </button>
          )}

          </div>
        </div>
        
        {isLoadingDirectRequest && (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50">
            <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
            <p className="ml-3 text-gray-700 font-medium">
              Chargement en cours...
            </p>
          </div>
        )}

        {/* </>)} */}
      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}>
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}

    </div>
  );
};

export default FormAchatEI
